import { Article } from '@/modules/shop/models/article';

function excludeb2bArticles(articles: Article[]): Article[] {
  return articles.filter((article) => article.attributes.channel !== 'b2b');
}

export default excludeb2bArticles;
